"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BtInstallmentsDialog = BtInstallmentsDialog;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _elements = require("@reservamos/elements");
var _reactI18next = require("react-i18next");
var _LocalizedCurrency = _interopRequireDefault(require("@/components/LocalizedCurrency"));
var _BtPlanRow = require("./BtPlanRow");
var _CardPreview = require("./CardPreview");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var InstallmentsCurrency = _LocalizedCurrency["default"];
var SINGLE_PAYMENT_VALUE = 1;
function capitalizeFirst(value) {
  return value ? "".concat(value.charAt(0).toUpperCase()).concat(value.slice(1)) : '';
}
function isInterestFree(plan) {
  var _ref, _plan$interestByMonth;
  return Number((_ref = (_plan$interestByMonth = plan.interestByMonth) !== null && _plan$interestByMonth !== void 0 ? _plan$interestByMonth : plan.interest) !== null && _ref !== void 0 ? _ref : 0) === 0;
}

/** Let the user review payment terms before committing the selected plan. */
function BtInstallmentsDialog(_ref2) {
  var cardPreview = _ref2.cardPreview,
    isOpen = _ref2.isOpen,
    onClose = _ref2.onClose,
    onSelectMonths = _ref2.onSelectMonths,
    onSelectSingle = _ref2.onSelectSingle,
    plans = _ref2.plans,
    selectedMonths = _ref2.selectedMonths,
    showInterest = _ref2.showInterest,
    totalAmount = _ref2.totalAmount;
  var _useTranslation = (0, _reactI18next.useTranslation)(['purchase', 'payment']),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(selectedMonths || SINGLE_PAYMENT_VALUE),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    temporaryMonths = _useState2[0],
    setTemporaryMonths = _useState2[1];
  (0, _react.useEffect)(function () {
    if (isOpen) setTemporaryMonths(selectedMonths || SINGLE_PAYMENT_VALUE);
  }, [isOpen, selectedMonths]);
  if (!isOpen) return null;
  function confirmSelection() {
    if (temporaryMonths <= SINGLE_PAYMENT_VALUE) onSelectSingle();else onSelectMonths(temporaryMonths);
    onClose();
  }
  function renderPlanLabel(prefix, amount) {
    return /*#__PURE__*/_react["default"].createElement(_elements.Text, {
      size: "S",
      weight: "bold",
      color: "grayStrong",
      elementType: "span",
      "data-sentry-element": "Text",
      "data-sentry-component": "renderPlanLabel",
      "data-sentry-source-file": "BtInstallmentsDialog.tsx"
    }, "".concat(prefix, " "), amount !== undefined && /*#__PURE__*/_react["default"].createElement(InstallmentsCurrency, {
      weight: "regular",
      color: "grayStrong",
      price: amount,
      currencyStyle: "currency",
      size: "S",
      currencyLowercase: true
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_elements.Modal, {
    title: t('purchase:bt_installments.dialog.title'),
    responsiveSize: "auto",
    contentHeight: "auto",
    headerColor: "primary",
    defaultOpened: true,
    onCloseModal: onClose,
    "data-sentry-element": "Modal",
    "data-sentry-component": "BtInstallmentsDialog",
    "data-sentry-source-file": "BtInstallmentsDialog.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/_react["default"].createElement(_CardPreview.CardPreview, {
    preview: cardPreview,
    "data-sentry-element": "CardPreview",
    "data-sentry-source-file": "BtInstallmentsDialog.tsx"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "max-h-[48vh] overflow-y-auto rounded-[15px] bg-gray-100 px-[14px] py-2"
  }, /*#__PURE__*/_react["default"].createElement(_BtPlanRow.BtPlanRow, {
    checked: temporaryMonths <= SINGLE_PAYMENT_VALUE,
    label: renderPlanLabel(t('purchase:bt_installments.dialog.single_payment_title'), totalAmount),
    onSelect: function onSelect() {
      return setTemporaryMonths(SINGLE_PAYMENT_VALUE);
    },
    "data-sentry-element": "BtPlanRow",
    "data-sentry-source-file": "BtInstallmentsDialog.tsx"
  }), plans.length > 0 && /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    weight: "semibold",
    size: "S",
    mobileSize: "S",
    color: "grayStrong"
  }, t('purchase:bt_installments.dialog.section_installments')), plans.map(function (plan) {
    var interestFree = isInterestFree(plan);
    return /*#__PURE__*/_react["default"].createElement(_BtPlanRow.BtPlanRow, {
      key: plan.months,
      checked: temporaryMonths === plan.months,
      label: renderPlanLabel("".concat(plan.months, " ").concat(t('payment:payments_of')), plan.monthlyPayment),
      tag: showInterest ? capitalizeFirst(t(interestFree ? 'purchase:bt_installments.without_interest' : 'purchase:bt_installments.with_interest')) : undefined,
      tagVariant: interestFree ? 'free' : 'with',
      onSelect: function onSelect() {
        return setTemporaryMonths(plan.months);
      }
    });
  })), /*#__PURE__*/_react["default"].createElement(_elements.Button, {
    text: t('purchase:bt_installments.dialog.confirm'),
    variant: "accent",
    withHeight: true,
    fullWidth: true,
    onClick: confirmSelection,
    minHeight: "48px",
    "data-sentry-element": "Button",
    "data-sentry-source-file": "BtInstallmentsDialog.tsx"
  })));
}